// extracted by mini-css-extract-plugin
export default {"new-comment":"NewComment_new-comment__+7z9V","form-group":"NewComment_form-group__y7Glp"};